import Chart from 'chart.js/auto';

const chartLoadingIndicator =
  "<div class='d-flex align-items-center justify-content-center py-5' role='status'>" +
    "<div class='spinner-grow text-dark'></div><span class='ml-2'>Loading chart...</span>" +
  "</div>";

document.addEventListener("DOMContentLoaded", () => {
  initialize_department_and_designation_options();
  initialize_trend_month_range();
  set_month_wise_gross_salary_graph(
    $(".month-wise-gross-salary-filter").val(),
    $(".gross-salary-currency-filter").val()
  );
  initialize_activity_related_to_graph();
});

const initialize_trend_month_range = () => {
  const from = document.getElementById("from_month");
  const to = document.getElementById("to_month");
  if (!from || !to) return;

  const monthNumber = (value) => Number(value.slice(0, 4)) * 12 + Number(value.slice(5, 7));
  const syncOptions = () => {
    const end = monthNumber(to.value);
    const options = Array.from(from.options);
    options.forEach((option) => {
      option.disabled = monthNumber(option.value) > end;
    });
    if (from.selectedOptions[0]?.disabled) {
      const earliest = options.reverse().find((option) => !option.disabled);
      if (earliest) from.value = earliest.value;
    }
  };

  to.addEventListener("change", syncOptions);
  syncOptions();
};

$(document).on(
  "change",
  ".month-wise-gross-salary-filter, .gross-salary-currency-filter",
  () => {
    set_month_wise_gross_salary_graph(
      $(".month-wise-gross-salary-filter").val(),
      $(".gross-salary-currency-filter").val()
    );
  }
);

$(document).on("reset", "#data_insight_filters_form", (e) => {
  hide_and_clear_dropdown($("#allowances_dropdown"));
  hide_and_clear_dropdown($("#claim_types_dropdown"));
  initialize_activity_related_to_graph();
  e.preventDefault();
});

$(document).on("ajax:beforeSend", "#data_insight_filters_form", () => {
  $("#activity-related-to-chart").html(chartLoadingIndicator);
  $("#activity-related-to-chart-summary").empty();
});

$(document).on("ajax:error", "#data_insight_filters_form", () => {
  $("#activity-related-to-chart").html("<p class='text-center text-danger py-5'>Unable to load chart.</p>");
});

const initialize_department_and_designation_options = () => {
  $("#department-options").on("change", function () {
    render_designation_options($(this).val());
  });
};

const render_designation_options = (selected_departments) => {
  if (window.location.pathname.split("/").at(-1) === "data_insights") {
    $.ajax({
      type: "GET",
      url: "/data_insights",
      dataType: "script",
      data: {
        department_ids: selected_departments,
        get_active_designations: true,
      },
    });
  }
};

const initialize_activity_related_to_graph = () => {
  if (window.location.pathname.split("/").at(-1) === "data_insights") {
    const isFinalSettlement = new URLSearchParams(window.location.search).get("analytic_category") === "final_settlement";
    const defaultFilter = isFinalSettlement ? "Gross Salary" : "Net Salary";
    $("#activity_related_to").val(defaultFilter).change();
    $("#designation-options").val("").multiselect("refresh");
    var allOptions = $("#department-options").find("option").not(":disabled");
    var valueArray = $.map(allOptions, function (option) {
      return option.value;
    });
    valueArray = valueArray.slice(0, 10);
    $("#analytics_from").val(
      $("#analytics_from").data("defualt-fiscal-year-start")
    );
    $("#analytics_till").val(
      $("#analytics_till").data("defualt-fiscal-year-end")
    );
    $("#department-options")
      .val(valueArray)
      .multiselect("refresh")
      .trigger("change");
    $("#apply-data_insight_filters").click();
  }
};

const set_month_wise_gross_salary_graph = (month_year, currency) => {
  if (window.location.pathname.split("/").at(-1) === "data_insights") {
    $.ajax({
      type: "GET",
      url: "/data_insights",
      dataType: "script",
      beforeSend: () => {
        $("#gross-salary-chart").html(chartLoadingIndicator);
      },
      error: () => {
        $("#gross-salary-chart").html("<p class='text-center text-danger py-5'>Unable to load chart.</p>");
        $(".net-gross-salary-amount, .avg-gross-salary-amount").empty();
      },
      data: {
        month_year: month_year,
        chart_type: "Month-wise Gross Salary",
        currency: currency,
        analytic_category: new URLSearchParams(window.location.search).get("analytic_category"),
      },
    });
  }
};

document.addEventListener('DOMContentLoaded', () => {
  const withheldMore = document.querySelector('[data-payroll-withheld-more]');
  if (withheldMore) {
    const rows = document.querySelector('[data-payroll-withheld-rows]');
    const status = document.querySelector('[data-payroll-withheld-status]');
    withheldMore.addEventListener('click', async () => {
      if (withheldMore.disabled) return;
      withheldMore.disabled = true;
      status.textContent = 'Loading employees...';
      try {
        const response = await fetch(withheldMore.dataset.url, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Unable to load employee details.');
        const data = await response.json();
        if (typeof data.rows !== 'string') throw new Error('Invalid employee details response.');
        rows.insertAdjacentHTML('beforeend', data.rows);
        withheldMore.dataset.url = data.next_url || '';
        withheldMore.classList.toggle('d-none', !data.next_url);
        status.textContent = '';
      } catch (_error) {
        status.textContent = 'Unable to load employees. Please try again.';
      } finally {
        withheldMore.disabled = false;
      }
    });
  }

  const drawer = document.querySelector('[data-payroll-details-dialog]');
  if (drawer) {
    const body = drawer.querySelector('[data-payroll-details-body]');
    const content = drawer.querySelector('.payroll-details-content');
    const status = drawer.querySelector('[data-payroll-details-status]');
    const retry = drawer.querySelector('[data-payroll-details-retry]');
    const searchForm = drawer.querySelector('[data-payroll-details-search]');
    const pagination = drawer.querySelector('[data-payroll-details-pagination]');
    const previousButton = drawer.querySelector('[data-payroll-details-previous]');
    const nextButton = drawer.querySelector('[data-payroll-details-next]');
    const headings = Array.from(drawer.querySelectorAll('thead th'));
    const defaultColumns = headings.map((heading) => heading.textContent);
    let request;
    let trigger;
    let searchVersion = 0;

    const loadPayrollDetails = async (url = drawer.dataset.payrollDetailsUrl) => {
      if (!url) return;
      if (request) request.abort();
      drawer.dataset.payrollDetailsUrl = url;
      body.replaceChildren();
      pagination.classList.add('d-none');
      content.scrollTop = 0;

      const currentRequest = new AbortController();
      request = currentRequest;
      status.textContent = 'Loading employees...';
      retry.classList.add('d-none');
      try {
        const response = await fetch(url, { headers: { Accept: 'application/json' }, signal: currentRequest.signal });
        if (!response.ok) throw new Error('Unable to load employee details.');
        const data = await response.json();
        if (request !== currentRequest) return;
        if (typeof data.rows !== 'string') throw new Error('Invalid employee details response.');
        body.insertAdjacentHTML('beforeend', data.rows);
        previousButton.dataset.url = data.previous_url || '';
        nextButton.dataset.url = data.next_url || '';
        previousButton.disabled = !data.previous_url;
        nextButton.disabled = !data.next_url;
        drawer.querySelector('[data-payroll-details-page]').textContent = `Page ${data.page}`;
        pagination.classList.remove('d-none');
        status.textContent = body.children.length ? '' : 'No employees in this row.';
      } catch (error) {
        if (error.name !== 'AbortError' && request === currentRequest) {
          status.textContent = 'Unable to load employee details. Please try again.';
          retry.classList.remove('d-none');
        }
      } finally {
        if (request === currentRequest) request = null;
      }
    };

    document.querySelectorAll('[data-payroll-details-open]').forEach((button) => {
      button.addEventListener('click', () => {
        trigger = button;
        searchForm.reset();
        drawer.dataset.payrollDetailsUrl = button.dataset.payrollDetailsUrl;
        drawer.querySelector('[data-payroll-details-title]').textContent = button.dataset.payrollDetailsTitle;
        const columns = button.dataset.payrollDetailsColumns ?
          button.dataset.payrollDetailsColumns.split('|') : defaultColumns;
        headings.forEach((heading, index) => {
          heading.textContent = columns[index] || '';
          heading.classList.toggle('d-none', index >= columns.length);
        });
        drawer.showModal();
        loadPayrollDetails();
      });
    });

    document.querySelectorAll('.payroll-department-summary-row').forEach((row) => {
      row.addEventListener('click', (event) => {
        if (!event.target.closest('[data-payroll-details-open]')) {
          row.querySelector('[data-payroll-details-open]').click();
        }
      });
    });

    drawer.querySelector('[data-payroll-details-close]').addEventListener('click', () => drawer.close());
    drawer.addEventListener('click', (event) => {
      if (event.target === drawer && event.clientX < drawer.getBoundingClientRect().left) drawer.close();
    });
    drawer.addEventListener('close', () => {
      searchVersion += 1;
      if (request) request.abort();
      request = null;
      trigger.focus();
    });
    retry.addEventListener('click', () => loadPayrollDetails());
    const searchEmployees = () => {
      const url = new URL(trigger.dataset.payrollDetailsUrl, window.location.origin);
      url.searchParams.set('search', searchForm.elements.search.value.trim());
      url.searchParams.delete('page');
      loadPayrollDetails(url.toString());
    };
    const searchAfterTyping = debounce((version) => {
      if (version === searchVersion) searchEmployees();
    }, 300);
    searchForm.elements.search.addEventListener('input', () => {
      if (request) request.abort();
      request = null;
      searchAfterTyping(++searchVersion);
    });
    searchForm.addEventListener('submit', (event) => {
      event.preventDefault();
      searchVersion += 1;
      searchEmployees();
    });
    [previousButton, nextButton].forEach((button) => {
      button.addEventListener('click', () => loadPayrollDetails(button.dataset.url));
    });
  }

  const canvas = document.getElementById('payroll-movement-waterfall');
  if (!canvas) return;

  const currency = canvas.dataset.currency;
  const previous = Number(canvas.dataset.previous);
  const current = Number(canvas.dataset.current);
  const steps = JSON.parse(canvas.dataset.steps).map((step) => ({
    ...step,
    amount: Number(step.amount),
  }));
  const labels = [['Previous', 'payroll'], ...steps.map((step) => step.label.split(' ')), ['Current', 'payroll']];
  canvas.parentElement.style.minWidth = `${Math.max(650, labels.length * 110)}px`;
  let running = previous;
  const movements = steps.map((step) => {
    const start = running;
    running += step.amount;
    return [start, running];
  });
  const format = (amount) => new Intl.NumberFormat('en', { maximumFractionDigits: 2 }).format(amount);
  const compact = (amount) => new Intl.NumberFormat('en', { notation: 'compact', maximumFractionDigits: 1 }).format(amount);
  const valueLabels = {
    id: 'payrollValueLabels',
    afterDatasetsDraw(chart) {
      const { ctx } = chart;
      ctx.save();
      ctx.strokeStyle = '#aab4bf';
      ctx.setLineDash([4, 4]);
      for (let index = 0; index < labels.length - 1; index += 1) {
        const from = chart.getDatasetMeta(index === 0 ? 0 : 1).data[index];
        const to = chart.getDatasetMeta(index === labels.length - 2 ? 0 : 1).data[index + 1];
        const level = index === 0 ? previous : movements[index - 1][1];
        const y = chart.scales.y.getPixelForValue(level);
        ctx.beginPath();
        ctx.moveTo(from.x + from.width / 2, y);
        ctx.lineTo(to.x - to.width / 2, y);
        ctx.stroke();
      }
      ctx.setLineDash([]);
      ctx.textAlign = 'center';
      ctx.font = '600 11px sans-serif';
      chart.data.datasets.forEach((dataset, datasetIndex) => {
        chart.getDatasetMeta(datasetIndex).data.forEach((bar, index) => {
          if (dataset.data[index] == null) return;
          const amount = datasetIndex === 0 ? (index === 0 ? previous : current) : steps[index - 1].amount;
          ctx.fillStyle = amount < 0 ? '#b43e4c' : '#334553';
          const label = `${amount > 0 && datasetIndex === 1 ? '+' : ''}${compact(amount)}`;
          ctx.fillText(label, bar.x, amount < 0 ? Math.max(bar.y, bar.base) + 15 : Math.min(bar.y, bar.base) - 8);
        });
      });
      ctx.restore();
    },
  };

  new Chart(canvas, {
    type: 'bar',
    plugins: [valueLabels],
    data: {
      labels,
      datasets: [
        {
          data: [previous, ...steps.map(() => null), current],
          grouped: false,
          backgroundColor: '#334553',
          borderRadius: 4,
          maxBarThickness: 58,
        },
        {
          data: [null, ...movements, null],
          grouped: false,
          backgroundColor: (context) => steps[context.dataIndex - 1]?.amount < 0 ? '#d96565' : '#42b88a',
          borderRadius: 4,
          maxBarThickness: 58,
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      layout: { padding: { top: 22 } },
      plugins: {
        legend: { display: false },
        tooltip: {
          mode: 'nearest',
          intersect: false,
          axis: 'x',
          filter: (item) => item.raw != null,
          callbacks: {
            title: (items) => labels[items[0].dataIndex].join(' '),
            label: (context) => {
              const step = steps[context.dataIndex - 1];
              const amount = step ? step.amount : context.dataIndex === 0 ? previous : current;
              const sign = amount < 0 ? '-' : step && amount > 0 ? '+' : '';
              return `${sign}${currency} ${format(Math.abs(amount))}`;
            },
            afterLabel: (context) => steps[context.dataIndex - 1]?.label === 'Remaining payroll components'
              ? 'Reconciles the gross payroll total with the listed components.' : '',
          },
        },
      },
      scales: {
        x: { grid: { display: false }, ticks: { color: '#4d5968' } },
        y: {
          beginAtZero: true,
          grid: { color: '#edf0f2' },
          ticks: { callback: compact },
          title: { display: true, text: `Gross payroll (${currency})` },
        },
      },
    },
  });
});
